import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import logo from "../../assets/logo.png";
import FooterLink from "./FooterLink";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';

export default function Footer() {

  return (
    <Box bgcolor="primary.footer" pb={3} pt={6} sx={{
      borderTop: "8px solid #EC1C24",
    }}>
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4.5}>
            <Stack
              alignItems="flex-start"
              justifyContent="space-between"
              height={1}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    padding: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box src={logo} height={44} alt="Medify" component="img" />
                </Box>
              </Box>
              <Typography
                fontWeight={300}
                color="#fff"
                fontSize={14}
                pt={2}
                mb={3}
              >VEM Plus Urgent Care is committed to providing exceptional healthcare services for our community. Our team ensures quick and reliable care with a focus on your well-being. </Typography>
              {/*<Stack direction="row" spacing={1.5}>*/}
              {/*  <Box component="img" src={fb} height={36} />*/}
              {/*  <Box component="img" src={twitter} height={36} />*/}
              {/*  <Box component="img" src={yt} height={36} />*/}
              {/*  <Box component="img" src={pinterest} height={36} />*/}
              {/*</Stack>*/}<div>&nbsp;</div>
            </Stack>
          </Grid>

          <Grid item xs={12} md={2.5}>
            <Typography
              fontWeight={600}
              color="#fff"
              fontSize={18}
              pt={2}
              mb={3}
            >Quick Links</Typography>
            <Stack spacing={2}>
              <FooterLink><a href="/about">About Us</a></FooterLink>
              <FooterLink><a href="/price" style={{ color: "#fff", textDecoration: "none" }}>Our Price</a></FooterLink>
              <FooterLink><a href="/gallery">Gallery</a></FooterLink>
              <FooterLink><a href="/privacy">Privacy Policy</a></FooterLink>
            </Stack>
          </Grid>


          <Grid item xs={12} md={2.5}>
            <Typography
              fontWeight={600}
              color="#fff"
              fontSize={18}
              pt={2}
              mb={2}
            >Services </Typography>
            <Stack spacing={2}>


              <FooterLink ><a href="/general-emergency-care">General & Emergency Care</a></FooterLink>
              <FooterLink ><a href= "/minor-surgeries">Minor Surgeries</a></FooterLink>
              <FooterLink ><a href="/diagnostics">ECG, USG, X-ray, CT, MRI</a></FooterLink>
              <FooterLink ><a href="/blood-tests">Blood Tests (Home Collection)</a></FooterLink>
              <FooterLink ><a href="/home-visit-injections">Home Visit & Injections</a></FooterLink>



            </Stack>
          </Grid>


          <Grid item xs={12} md={2.5}>
            <Typography
              fontWeight={600}
              color="#fff"
              fontSize={18}
              pt={2}
              mb={3}
            >Contact Us</Typography>
            <Stack spacing={2}>
              <FooterLink><LocationOnIcon />Head Office- 73, Ground Floor, Emerald Plaza, 65 Gurgaon</FooterLink>
              <FooterLink><LocationOnIcon />Branch Office- Shop No-AFF20, 1st Floor, Signtaure Global The Millennia-1, Sector-37, Gurgaon</FooterLink>
              <FooterLink><CallIcon />+91 9716467981</FooterLink>
              <FooterLink><EmailIcon />amit.vishen@vemplusurgentcare.com</FooterLink>
            </Stack>
          </Grid>
        </Grid>

        <Typography
          fontWeight={300}
          color="#fff"
          fontSize={14}
          pt={3}
          mt={5}
          borderTop="1px solid rgba(255,255,255,0.1)"
        >
          Copyright ©2024 VEM Plus Urgent Care. All Rights Reserved
        </Typography>
      </Container>
    </Box>
  );
}
